import ouiBase from '@goldwasserexchange/oui';
import { useAccountOrderFieldApiByOpbFordId } from '../api';

export const useAccountOrderOpbFordDQt = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountOrderFieldApiByOpbFordId({
    opbFordDId,
    field: 'OPB_FORD_D.QT',
  });
  return response;
};
